import { ShiftService, EmployeesService, AccountsService } from '../../services';
import * as moment from 'moment';
export const shiftState: aboTheme.IState = {

  parent: 'app',
  name: "shifts",
  url: "/shifts",
  component: 'shiftComponent',
  redirectTo: 'shifts.list',
  data: {
    permissions: {
        only: ['BACKOFFICE'],
        redirectTo: 'schedule'
    }
  }

};

export const shiftCalendarState: aboTheme.IState = {

  name: "shifts.calendar",
  url: "/calendar",
  views: {
    "main": 'shiftCalendarComponent'
  }
};

export const shiftItemState = {

  name: "shifts.calendar.item",
  url: "/item/:id",
  modal: true,
  size: "lg",
  component: 'shiftItemComponent',
  resolve: {
    shift: (ShiftService: ShiftService, $stateParams: ng.ui.IStateParamsService) => {
      "ngInject";
      if ($stateParams['id']) {
        return ShiftService.get($stateParams['id']);
      }
    },
    functions : (MasterdataService: aboMasterdata.IService) => { "ngInject"; return MasterdataService.getItems('Functions'); },
    accounts : (AccountsService: AccountsService) => { "ngInject"; return AccountsService.all(); },
    employees : (EmployeesService: EmployeesService) => { "ngInject"; return EmployeesService.getEmployeesByStatus(); },
    statuses : (MasterdataService: aboMasterdata.IService) => { "ngInject"; return MasterdataService.getItems('ShiftStatus'); }
  }
};

export const shiftListState: aboTheme.IState = {
  name: "shifts.list",
  url: "/list?:start&:end&:refreshShift",
  params: {
    "start" : { dynamic: true } ,
    "end" :  { dynamic: true },
    "refreshShift" :  { dynamic: true }  
  },
  views: {
    "main": 'shiftListComponent'
  },
  resolve: {
    functions : (MasterdataService: aboMasterdata.IService) => { "ngInject"; return MasterdataService.getItems('Functions'); },
    statuses : (MasterdataService: aboMasterdata.IService) => { "ngInject"; return MasterdataService.getItems('ShiftStatus'); },
    employees : (EmployeesService: EmployeesService, PermPermissionStore: ng.permission.PermissionStore) => { 
      "ngInject"; return EmployeesService.getEmployeesByStatus(); 
    },
    accounts : (AccountsService: AccountsService ) => { "ngInject"; return AccountsService.all(); },
  },
  data: {
    contentClasses: 'no-padding'
  }
};

export const shiftListItemState = {
  name: "shifts.list.item",
  url: "/item/:id",
  resolve: {
    shift: (ShiftService: ShiftService, $stateParams: ng.ui.IStateParamsService) => {
      "ngInject";
      if ($stateParams['id']) {
        return ShiftService.get($stateParams['id']);
      }
    },
  },
  views: {
    "shiflistitem@shifts.list": 'shiftListItemComponent'
  },
};

export const shiftListSubscriptionsModalState = {
  name: "shifts.list.subscriptionsmodal",
  url: "/subscriptions/:id",
  modal: true,
  size: "lg",
  component: 'subscriptionsModalComponent',
  resolve: {
    shift: (ShiftService: ShiftService, $stateParams: ng.ui.IStateParamsService) => {
      "ngInject";
      if ($stateParams['id']) {
        return ShiftService.get($stateParams['id']);
      }
    },
    statuses : (MasterdataService: aboMasterdata.IService) => { "ngInject"; return MasterdataService.getItems('ShiftStatus'); },
    functions : (MasterdataService: aboMasterdata.IService) => { "ngInject"; return MasterdataService.getItems('Functions'); }
  }
};

export const shiftListEmployeeState = {
  name: "shifts.list.item.employee",
  url: "/employee",
  params : {
    filter : null
  },
  resolve: {

  },
  views: {
    "shiflistitem@shifts.list": 'shiftListEmployeeComponent'
  },
};

export const checkAvailabilityState = {

  name: "shifts.list.checkAvailability",
  url: "/checkAvailability",
  modal: true,
  component: 'checkAvailabilityModalComponent',
  size: "huge",
  resolve: {
    functions : (MasterdataService: aboMasterdata.IService) => { "ngInject"; return MasterdataService.getItems('Functions'); },
    accounts : (AccountsService: AccountsService) => { "ngInject"; return AccountsService.all(); }
  }

};


// WEBPACK FOOTER //
// ./src/app/modules/shifts/shift.states.ts